import { Component, OnInit } from '@angular/core';
/*App imports*/
import { HelpersService } from '../../services/tools/helpers.service';
import { ReportesPagosService } from '../../services/reportes/reportes-pagos.service';
import { ReportsHelperService } from '../../services/tools/reports-helpers.service';
import { CreditosService } from "../../services/creditos.service";
import { SucursalesService } from '../../services/sucursales.service';

@Component({
    selector: 'reporte-pagos',
    templateUrl: './reporte-pagos.component.html'
  })

export class ReportePagosComponent implements OnInit {

    public reportData: any [] = [];
    public totales: any = {};
    public fechaInicio: string = null;
    public fechaFin: string = null;
    public tipoCredito: string = '';
    public tiposCreditos: any[] = [];
    public isLoading: boolean = true;

    public sucursales: any[] = [];
    public sucursal: any = {id:null};
    public sucursalPorDefecto: string = "";

    constructor(
        private helperService: HelpersService,
        private reportesService: ReportesPagosService,
        private creditosService: CreditosService,
        private sucursalesService : SucursalesService,
        public helper: ReportsHelperService
    ){

    }

    public ngOnInit() {
        this.getTiposCreditos();
        this.getSucursales();
    }

    private getSucursales(){
        this.isLoading = true;
        this.sucursalesService.get().subscribe(
          (response)=>
          {
            const jsonResult = response.json();
            if(jsonResult.content){
              this.sucursales = jsonResult.content.data;
              if (this.sucursales.length>1){
                this.sucursalPorDefecto = "Seleccione";
              } else if(this.sucursales.length>0){
                this.sucursal =  this.sucursales[0];
              }
              this.isLoading = false;
              this.setupDefaultState(); 
            }
            
          }, error =>
          {
            // se resuelve error 403 y 500
            this.isLoading = false;
            this.helperService.httpGlobalError(error);
    
            if(error.status == 400) {
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
        );
    }
    
    sucursalChanged(sucursal){
        if(sucursal){
        this.sucursal = sucursal;
        this.updateReporte();
        }
    }

    private setupDefaultState() {
        let defaultDates = this.helper.getDefaultDates();
        
        this.fechaInicio = defaultDates.fechaInicio;
        this.fechaFin = defaultDates.fechaFin;

        this.updateReporte();
    }

    public updateReporte(){

        let filters = {
            fechaInicio: this.fechaInicio,
            fechaFin: this.fechaFin,
            tipoCredito: this.tipoCredito,
            sucursal : this.sucursal.id
        }

        //Mostrar el ajax loading
        this.isLoading = true;

        this.reportesService.general(filters).subscribe(
            (response)=>
            {
                const jsonResult = response.json();
                let items = [];
                let totales = {};
                if(jsonResult.content ){
                    if(jsonResult.content.items){
                        items = jsonResult.content.items;
                    }
                    if(jsonResult.content.totales){
                        totales = jsonResult.content.totales;
                    }
                }

                this.reportData = items;
                this.totales = totales;
                this.isLoading = false;
            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }

    private getTiposCreditos(){
        this.creditosService.getTiposCreditos().subscribe(
            (response)=>
            {
                const jsonResult = response.json();
                if(jsonResult.content){
                    this.tiposCreditos = jsonResult.content;
                }
            }, error =>
            {
                // se resuelve error 403 y 500
                this.helperService.httpGlobalError(error);

                if(error.status == 400) {
                    this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
                }
            }
        );
    }

    public print(){
        //Imprimir pantalla
        window.print();
    }

    public descargar() {

        let filters = {
            fechaInicio: this.fechaInicio,
            fechaFin: this.fechaFin,
            sucursal : this.sucursal.id,
            tipoCredito: this.tipoCredito
        }

        this.reportesService.exportToExcel(filters).subscribe(
            (response)=>
            {
            const fileUrl = window.URL.createObjectURL(response.blob());
            //Muestra el archivo en una nueva ventana
            window.open(fileUrl);
            }, async error =>
            {
            // se resuelve error 403 y 500
            const imagen_response = await fetch(error);
            const imagen_blob = await imagen_response.blob();
            let fr = new FileReader()
            fr.onload = function(e) {
                console.log(e)
            };
            
            fr.readAsText(imagen_blob);
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/reportes/pagos/reporte-pagos.component.ts